var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _path21, _path22, _circle, _path23, _path24, _path25, _path26, _path27, _path28, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeroBannerMobile = function SvgHeroBannerMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1000 160"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heroBannerMobile_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heroBannerMobile_svg__b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__c)",
    d: "M0 0h1686.15v69.231H0z",
    transform: "rotate(3.587 676.498 -6664.744)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__d)",
    fillRule: "evenodd",
    d: "m5.502-27.44-18.46 16.283L2.307 6.15l-17.306 15.265 16.283 18.46L18.59 24.611l15.264 17.306 18.46-16.283L37.052 8.328 54.358-6.937l-16.282-18.46-17.308 15.265z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__e)",
    fillRule: "evenodd",
    d: "M72.819-23.22 54.359-6.937 69.623 10.37 52.318 25.635 68.6 44.095l17.306-15.264 15.265 17.306 18.46-16.282-15.264-17.307 17.307-15.265-16.282-18.46L88.084-5.913z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m140.134-19-18.46 16.283 15.265 17.308-17.306 15.264 16.283 18.46 17.306-15.264 15.264 17.306 18.461-16.282-15.265-17.306L188.99 1.503l-16.283-18.46L155.4-1.693z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__f)",
    fillRule: "evenodd",
    d: "m140.134-19-18.46 16.283 15.265 17.308-17.306 15.264 16.283 18.46 17.306-15.264 15.264 17.306 18.461-16.282-15.265-17.306L188.99 1.503l-16.283-18.46L155.4-1.693z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__g)",
    fillRule: "evenodd",
    d: "M207.451-14.78 188.99 1.503l15.266 17.308-17.307 15.264 16.283 18.46 17.306-15.264 15.264 17.306 18.461-16.282-15.264-17.307 17.307-15.265-16.282-18.46-17.308 15.265z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "heroBannerMobile_svg__i",
    width: 71,
    height: 70,
    x: 186,
    y: -15,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__h)",
    d: "m256.306 5.723-16.283-18.46-32.572-2.043L188.99 1.503l-2.041 32.572 16.282 18.46 17.307-15.264 15.264 17.306 18.461-16.282z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m274.765-10.56-18.46 16.283L271.57 23.03l-17.306 15.264 16.282 18.461 17.307-15.264 15.264 17.306 18.461-16.283-15.265-17.306 17.308-15.265-16.283-18.46-17.307 15.265z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__j)",
    fillRule: "evenodd",
    d: "m274.765-10.56-18.46 16.283L271.57 23.03l-17.306 15.264 16.282 18.461 17.307-15.264 15.264 17.306 18.461-16.283-15.265-17.306 17.308-15.265-16.283-18.46-17.307 15.265z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M342.082-6.34 323.621 9.943l15.265 17.307-17.306 15.265 16.283 18.46 17.306-15.264 15.264 17.306 18.461-16.282-15.264-17.306 17.307-15.266-16.282-18.46-17.308 15.265z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__k)",
    fillRule: "evenodd",
    d: "M342.082-6.34 323.621 9.943l15.265 17.307-17.306 15.265 16.283 18.46 17.306-15.264 15.264 17.306 18.461-16.282-15.264-17.306 17.307-15.266-16.282-18.46-17.308 15.265z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__l)",
    fillRule: "evenodd",
    d: "m409.398-2.12-18.461 16.283 15.266 17.307-17.306 15.265 16.282 18.46 17.306-15.264 15.265 17.306 18.46-16.282-15.264-17.307 17.308-15.265-16.283-18.46-17.308 15.265z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m476.714 2.1-18.46 16.283 15.265 17.308-17.306 15.264 16.283 18.46 17.306-15.264 15.264 17.306 18.461-16.282-15.265-17.306 17.308-15.266-16.283-18.46-17.307 15.265z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__m)",
    fillRule: "evenodd",
    d: "m476.714 2.1-18.46 16.283 15.265 17.308-17.306 15.264 16.283 18.46 17.306-15.264 15.264 17.306 18.461-16.282-15.265-17.306 17.308-15.266-16.283-18.46-17.307 15.265z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__n)",
    fillRule: "evenodd",
    d: "M544.031 6.32 525.57 22.603l15.266 17.308-17.307 15.264 16.283 18.46 17.306-15.264 15.265 17.306 18.46-16.282-15.264-17.306 17.307-15.266-16.282-18.46-17.308 15.265z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m611.346 10.54-18.46 16.283 15.265 17.307-17.306 15.265 16.283 18.46 17.306-15.264 15.264 17.306 18.461-16.283-15.265-17.306 17.308-15.265-16.283-18.46-17.307 15.265z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__o)",
    fillRule: "evenodd",
    d: "m611.346 10.54-18.46 16.283 15.265 17.307-17.306 15.265 16.283 18.46 17.306-15.264 15.264 17.306 18.461-16.283-15.265-17.306 17.308-15.265-16.283-18.46-17.307 15.265z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#heroBannerMobile_svg__p)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.692,
    d: "m608.856 25.8 34.548 2.165-.193 3.07-36.713 32.382"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__q)",
    fillRule: "evenodd",
    d: "m678.663 14.76-18.461 16.283 15.266 17.308-17.307 15.264 16.283 18.46 17.306-15.264 15.264 17.307 18.461-16.283-15.264-17.306 17.307-15.266-16.282-18.46-17.308 15.265z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "heroBannerMobile_svg__s",
    width: 70,
    height: 71,
    x: 658,
    y: 14,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__r)",
    d: "m727.518 35.263-16.283-18.46-32.572-2.042-18.461 16.282-2.041 32.572 16.282 18.46 17.307-15.264 15.264 17.307 18.461-16.283z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#heroBannerMobile_svg__s)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#heroBannerMobile_svg__t)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.692,
    d: "m708.181 27.402-28.406-1.78-1.251 19.96 16.506 1.035c7.42.465 13.058 6.857 12.593 14.277l-.024.384c-.452 7.208-6.661 12.685-13.87 12.233v0"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m745.977 18.98-18.461 16.283 15.266 17.308-17.306 15.264 16.282 18.46 17.307-15.264 15.264 17.306 18.46-16.282-15.264-17.307 17.308-15.265-16.283-18.46-17.307 15.265z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__u)",
    fillRule: "evenodd",
    d: "m745.977 18.98-18.461 16.283 15.266 17.308-17.306 15.264 16.282 18.46 17.307-15.264 15.264 17.306 18.46-16.282-15.264-17.307 17.308-15.265-16.283-18.46-17.307 15.265z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 760.526,
    cy: 53.034,
    r: 20.769,
    stroke: "url(#heroBannerMobile_svg__v)",
    strokeWidth: 7.692,
    transform: "rotate(3.587 760.526 53.034)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__w)",
    fillRule: "evenodd",
    d: "m813.293 23.2-18.46 16.283 15.265 17.308-17.306 15.264 16.283 18.46 17.306-15.264 15.264 17.307 18.461-16.283-15.264-17.306 17.307-15.266-16.282-18.46-17.308 15.265z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m880.61 27.42-18.461 16.283 15.266 17.308-17.306 15.264 16.282 18.46 17.306-15.264 15.265 17.307 18.46-16.283-15.264-17.306 17.307-15.266-16.282-18.46-17.308 15.265z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__x)",
    fillRule: "evenodd",
    d: "m880.61 27.42-18.461 16.283 15.266 17.308-17.306 15.264 16.282 18.46 17.306-15.264 15.265 17.307 18.46-16.283-15.264-17.306 17.307-15.266-16.282-18.46-17.308 15.265z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__y)",
    fillRule: "evenodd",
    d: "m947.926 31.64-18.46 16.283 15.265 17.308-17.306 15.264 16.283 18.46 17.306-15.263 15.264 17.306 18.461-16.283-15.265-17.306 17.308-15.266-16.283-18.46-17.307 15.265z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m1043.6 105.218 18.46-16.283-15.27-17.307 17.31-15.265-16.29-18.46-17.3 15.264-15.27-17.306-18.457 16.283 15.267 17.306-17.31 15.265 16.28 18.461 17.31-15.266z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__z)",
    fillRule: "evenodd",
    d: "m1043.6 105.218 18.46-16.283-15.27-17.307 17.31-15.265-16.29-18.46-17.3 15.264-15.27-17.306-18.457 16.283 15.267 17.306-17.31 15.265 16.28 18.461 17.31-15.266z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heroBannerMobile_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#heroBannerMobile_svg__B)",
    d: "M0 0h2101.54v69.231H0z",
    transform: "translate(-578.462 90.77)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m-161.987 131.681-8.337 1.113.006.006c.521 4.513 1.777 7.727 3.759 9.636q2.973 2.866 9.187 2.867c3.926 0 7.02-1.023 9.259-3.058 2.238-2.035 3.363-4.842 3.363-8.409 0-2.933-.616-5.267-1.861-6.997s-3.328-3.19-6.26-4.387l-2.987-1.221c-1.957-.796-3.28-1.514-3.98-2.149-.7-.634-1.048-1.472-1.048-2.579s.324-1.975.964-2.598q.97-.94 2.675-.939 1.85 0 2.784 1.346.94 1.345 1.101 4.226l8.337-1.113c-.473-4.064-1.718-7.069-3.747-9.026q-3.042-2.934-8.66-2.933-5.62 0-8.834 3.07-3.222 3.072-3.22 8.452c0 2.932.694 5.35 2.077 7.242 1.388 1.891 3.489 3.387 6.314 4.495l3.286 1.274q2.368.923 3.274 1.874c.604.634.91 1.436.91 2.525q.001 1.635-.976 2.514-.977.888-2.771.886-4.291-.001-4.615-6.117m-46.127 13.179v-38.97h10.073l7.056 21.391 7.003-21.391h9.612v38.97h-8.337v-23.695l-5.375 16.01h-6.296l-5.375-15.95v23.641h-8.361zm-11.917 0-1.382-6.847h-9.014l-1.383 6.847h-8.361l9.529-38.969h9.989l9.504 38.969h-8.882m-8.852-14.454h5.89l-2.933-14.43zm93.089 14.454v-31.171h-7.739v-7.798h24.431v7.798h-7.792v31.171zm19.839-38.969v38.975h19.984v-7.798h-11.24v-8.182h9.45v-7.775h-9.45v-7.422h10.941v-7.798zm24.516 38.97v-38.97h13.143q5.728-.001 8.727 3.22 2.998 3.222 2.998 9.361 0 4.076-1.508 6.859c-1.005 1.855-2.466 3.214-4.387 4.064l7.278 15.466h-9.72l-5.973-13.808h-1.658v13.808zm12.138-31.387h-3.232V123.5h3.232c1.305 0 2.292-.425 2.975-1.275q1.016-1.275 1.017-3.753.001-5-3.992-4.998m17.807-7.583v38.969h10.917q7.71 0 11.527-4.794c2.544-3.196 3.813-7.93 3.813-14.526q0-9.894-3.813-14.771-3.815-4.877-11.528-4.878zm15.62 28.477q-1.452 2.694-4.763 2.694v-.006h-1.957v-23.372h1.957c2.208 0 3.794.921 4.764 2.771s1.454 4.985 1.454 9.079q0 6.141-1.454 8.834m30.8 10.492-1.383-6.847h-9.014l-1.382 6.847h-8.361l9.528-38.969h9.99l9.504 38.969h-8.882m-8.852-14.454h5.889l-2.933-14.43zm20.768-24.515v38.975h8.362v-23.641l5.374 15.95h6.297l5.374-16.01v23.695h8.338v-38.969h-9.612l-7.003 21.391-7.057-21.391z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m49.394 135.129 3.244-3.244 3.244 3.244-3.244 3.244 3.244 3.243-.012.012-3.244 3.244-3.244-3.244-3.243 3.244-3.245-3.244 3.257-3.255-3.245-3.244 3.245-3.244zm-3.243-16.238-3.245 3.244 3.245 3.244-3.257 3.256 3.245 3.244 3.243-3.244 3.244 3.244 3.244-3.244.012-.012-3.244-3.244 3.244-3.244-3.244-3.244-3.244 3.244zm0-12.994-3.245 3.244 3.245 3.244-3.257 3.256 3.245 3.244 3.243-3.244 3.244 3.244 3.244-3.244.012-.012-3.244-3.244 3.244-3.244-3.244-3.244-3.244 3.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M132.062 145.303c4.249 0 7.493-1.694 9.732-5.093 2.232-3.4 3.351-8.338 3.351-14.826 0-6.487-1.119-11.425-3.351-14.825q-3.35-5.091-9.732-5.093c-4.256 0-7.494 1.694-9.72 5.093s-3.34 8.338-3.34 14.825q0 9.734 3.34 14.826c2.226 3.393 5.47 5.093 9.72 5.093m0-7.775c-1.395 0-2.388-.939-2.987-2.825-.598-1.879-.898-4.991-.898-9.319 0-4.327.3-7.433.898-9.306q.897-2.812 2.987-2.813 2.091.001 2.998 2.813c.605 1.873.91 4.979.91 9.306q-.001 6.492-.91 9.319c-.604 1.886-1.604 2.825-2.998 2.825m-41.86-23.833-10.994 31.171H69.98l11.623-31.171H68.19v-7.798h22.02v7.798zm13.953 31.609q-5.349-.001-8.607-2.634c-2.172-1.759-3.531-4.363-4.07-7.828l8.768-1.658q.326 4.345 3.747 4.345c1.179 0 2.089-.461 2.741-1.389s.976-2.28.976-4.075q0-2.881-.952-4.334-.95-1.454-2.663-1.454-2.632-.001-3.693 2.663l-8.062-.76 1.466-22.283h20.853v7.799h-13.084l-.598 7.529q2.199-2.118 5.566-2.118c3.058 0 5.5 1.107 7.314 3.315q2.729 3.313 2.729 9.158c0 4.351-1.149 7.721-3.447 10.121s-5.297 3.603-8.984 3.603",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m163.953 135.129 3.244-3.244 3.244 3.244-3.244 3.244 3.244 3.243-.012.012-3.244 3.244-3.244-3.244-3.244 3.244-3.244-3.244 3.256-3.255-3.244-3.244 3.244-3.244zm-3.244-16.238-3.244 3.244 3.244 3.244-3.256 3.256 3.244 3.244 3.244-3.244 3.244 3.244 3.244-3.244.012-.012-3.244-3.244 3.244-3.244-3.244-3.244-3.244 3.244zm0-12.994-3.244 3.244 3.244 3.244-3.256 3.256 3.244 3.244 3.244-3.244 3.244 3.244 3.244-3.244.012-.012-3.244-3.244 3.244-3.244-3.244-3.244-3.244 3.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m260.933 131.681-8.337 1.113.006.006c.52 4.513 1.777 7.727 3.758 9.636q2.974 2.866 9.188 2.867c3.926 0 7.02-1.023 9.259-3.058 2.238-2.035 3.363-4.842 3.363-8.409 0-2.933-.616-5.267-1.861-6.997s-3.328-3.19-6.26-4.387l-2.987-1.221c-1.957-.796-3.28-1.514-3.98-2.149-.7-.634-1.048-1.472-1.048-2.579s.324-1.975.964-2.598q.97-.94 2.675-.939 1.85 0 2.783 1.346.942 1.345 1.102 4.226l8.337-1.113c-.473-4.064-1.718-7.069-3.747-9.026s-4.913-2.933-8.66-2.933q-5.62 0-8.834 3.07-3.222 3.072-3.22 8.452c0 2.932.694 5.35 2.077 7.242 1.388 1.891 3.489 3.387 6.314 4.495l3.286 1.274q2.368.923 3.274 1.874c.604.634.909 1.436.909 2.525q.002 1.635-.975 2.514-.978.888-2.771.886-4.291-.001-4.615-6.117m-46.127 13.179v-38.97h10.073l7.056 21.391 7.003-21.391h9.612v38.97h-8.337v-23.695l-5.375 16.01h-6.296l-5.375-15.95v23.641h-8.361zm-11.917 0-1.382-6.847h-9.014l-1.383 6.847h-8.361l9.528-38.969h9.99l9.504 38.969h-8.882m-8.852-14.454h5.889l-2.932-14.43zm93.089 14.454v-31.171h-7.739v-7.798h24.431v7.798h-7.793v31.171zm19.839-38.969v38.975h19.984v-7.798h-11.24v-8.182h9.451v-7.775h-9.451v-7.422h10.941v-7.798zm24.516 38.97v-38.97h13.143q5.729-.001 8.727 3.22t2.998 9.361q0 4.076-1.508 6.859c-1.005 1.855-2.466 3.214-4.387 4.064l7.278 15.466h-9.72l-5.973-13.808h-1.658v13.808zm12.138-31.387h-3.232V123.5h3.232c1.305 0 2.292-.425 2.975-1.275q1.016-1.275 1.017-3.753.001-5-3.992-4.998m17.806-7.583v38.969h10.917q7.712 0 11.528-4.794c2.544-3.196 3.812-7.93 3.812-14.526 0-6.595-1.268-11.521-3.812-14.771q-3.815-4.877-11.528-4.878zm15.622 28.477q-1.453 2.694-4.764 2.694v-.006h-1.958v-23.372h1.958c2.208 0 3.794.921 4.764 2.771.969 1.849 1.454 4.985 1.454 9.079q0 6.141-1.454 8.834m30.799 10.492-1.383-6.847h-9.014l-1.382 6.847h-8.362l9.529-38.969h9.989l9.505 38.969h-8.882m-8.853-14.454h5.89l-2.933-14.43zm20.769-24.515v38.975h8.362v-23.641l5.374 15.95h6.297l5.374-16.01v23.695h8.338v-38.969h-9.613l-7.002 21.391-7.057-21.391z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m472.314 135.129 3.244-3.244 3.244 3.244-3.244 3.244 3.244 3.243-.012.012-3.244 3.244-3.244-3.244-3.244 3.244-3.244-3.244 3.256-3.255-3.244-3.244 3.244-3.244zm-3.244-16.238-3.244 3.244 3.244 3.244-3.256 3.256 3.244 3.244 3.244-3.244 3.244 3.244 3.244-3.244.012-.012-3.244-3.244 3.244-3.244-3.244-3.244-3.244 3.244zm0-12.994-3.244 3.244 3.244 3.244-3.256 3.256 3.244 3.244 3.244-3.244 3.244 3.244 3.244-3.244.012-.012-3.244-3.244 3.244-3.244-3.244-3.244-3.244 3.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M554.982 145.303c4.249 0 7.493-1.694 9.732-5.093 2.232-3.4 3.351-8.338 3.351-14.826 0-6.487-1.119-11.425-3.351-14.825q-3.35-5.091-9.732-5.093c-4.256 0-7.494 1.694-9.72 5.093s-3.34 8.338-3.34 14.825q0 9.734 3.34 14.826c2.226 3.393 5.47 5.093 9.72 5.093m0-7.775c-1.395 0-2.388-.939-2.987-2.825-.598-1.879-.898-4.991-.898-9.319 0-4.327.3-7.433.898-9.306.599-1.874 1.592-2.813 2.987-2.813q2.091.001 2.998 2.813c.605 1.873.91 4.979.91 9.306q-.001 6.492-.91 9.319c-.604 1.886-1.604 2.825-2.998 2.825m-41.859-23.833-10.995 31.171h-9.229l11.623-31.171h-13.413v-7.798h22.02v7.798zm13.952 31.609q-5.349-.001-8.607-2.634c-2.173-1.759-3.531-4.363-4.07-7.828l8.768-1.658q.326 4.345 3.747 4.345c1.179 0 2.089-.461 2.741-1.389s.976-2.28.976-4.075q0-2.881-.952-4.334-.95-1.454-2.663-1.454-2.632-.001-3.693 2.663l-8.062-.76 1.466-22.283h20.853v7.799h-13.084l-.598 7.529q2.199-2.118 5.566-2.118c3.058 0 5.5 1.107 7.314 3.315q2.729 3.313 2.729 9.158c0 4.351-1.149 7.721-3.448 10.121s-5.296 3.603-8.983 3.603",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m586.873 135.129 3.244-3.244 3.244 3.244-3.244 3.244 3.244 3.243-.012.012-3.244 3.244-3.244-3.244-3.244 3.244-3.244-3.244 3.256-3.255-3.244-3.244 3.244-3.244zm-3.244-16.238-3.244 3.244 3.244 3.244-3.256 3.256 3.244 3.244 3.244-3.244 3.244 3.244 3.244-3.244.012-.012-3.244-3.244 3.244-3.244-3.244-3.244-3.244 3.244zm0-12.994-3.244 3.244 3.244 3.244-3.256 3.256 3.244 3.244 3.244-3.244 3.244 3.244 3.244-3.244.012-.012-3.244-3.244 3.244-3.244-3.244-3.244-3.244 3.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m683.853 131.681-8.337 1.113.006.006c.52 4.513 1.777 7.727 3.758 9.636q2.973 2.866 9.188 2.867c3.926 0 7.02-1.023 9.259-3.058 2.238-2.035 3.363-4.842 3.363-8.409 0-2.933-.616-5.267-1.861-6.997s-3.328-3.19-6.261-4.387l-2.986-1.221c-1.957-.796-3.28-1.514-3.98-2.149-.701-.634-1.048-1.472-1.048-2.579q.002-1.662.964-2.598.97-.94 2.675-.939 1.85 0 2.783 1.346.942 1.345 1.102 4.226l8.337-1.113c-.473-4.064-1.718-7.069-3.747-9.026s-4.913-2.933-8.66-2.933q-5.62 0-8.834 3.07-3.222 3.072-3.22 8.452c0 2.932.694 5.35 2.076 7.242 1.389 1.891 3.49 3.387 6.315 4.495l3.286 1.274q2.368.923 3.274 1.874c.604.634.909 1.436.909 2.525q.002 1.635-.975 2.514c-.653.593-1.574.886-2.771.886q-4.291-.001-4.615-6.117m-46.127 13.179v-38.97h10.073l7.056 21.391 7.003-21.391h9.612v38.97h-8.337v-23.695l-5.375 16.01h-6.296l-5.375-15.95v23.641h-8.361zm-11.917 0-1.383-6.847h-9.013l-1.383 6.847h-8.361l9.528-38.969h9.99l9.504 38.969h-8.882m-8.852-14.454h5.889l-2.932-14.43zm93.088 14.454v-31.171h-7.738v-7.798h24.431v7.798h-7.793v31.171zm19.84-38.969v38.975h19.984v-7.798h-11.24v-8.182h9.451v-7.775h-9.451v-7.422h10.941v-7.798zm24.516 38.97v-38.97h13.143q5.729-.001 8.727 3.22t2.998 9.361q0 4.076-1.508 6.859c-1.006 1.855-2.466 3.214-4.387 4.064l7.278 15.466h-9.72l-5.973-13.808h-1.658v13.808zm12.138-31.387h-3.232V123.5h3.232c1.305 0 2.292-.425 2.974-1.275q1.017-1.275 1.018-3.753.001-5-3.992-4.998m17.806-7.583v38.969h10.917q7.713 0 11.528-4.794c2.543-3.196 3.812-7.93 3.812-14.526q.001-9.894-3.812-14.771-3.815-4.877-11.528-4.878zm15.622 28.477q-1.453 2.694-4.765 2.694v-.006h-1.957v-23.372h1.957c2.209 0 3.795.921 4.765 2.771s1.454 4.985 1.454 9.079q0 6.141-1.454 8.834m30.799 10.492-1.383-6.847h-9.014l-1.382 6.847h-8.362l9.529-38.969h9.989l9.504 38.969h-8.881m-8.853-14.454h5.89l-2.933-14.43zm20.769-24.515v38.975h8.361v-23.641l5.375 15.95h6.297l5.374-16.01v23.695h8.338v-38.969h-9.613l-7.002 21.391-7.057-21.391z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m895.234 135.129 3.244-3.244 3.244 3.244-3.244 3.244 3.244 3.243-.012.012-3.244 3.244-3.244-3.244-3.244 3.244-3.244-3.244 3.256-3.255-3.244-3.244 3.244-3.244zm-3.244-16.238-3.244 3.244 3.244 3.244-3.256 3.256 3.244 3.244 3.244-3.244 3.244 3.244 3.244-3.244.012-.012-3.244-3.244 3.244-3.244-3.244-3.244-3.244 3.244zm0-12.994-3.244 3.244 3.244 3.244-3.256 3.256 3.244 3.244 3.244-3.244 3.244 3.244 3.244-3.244.012-.012-3.244-3.244 3.244-3.244-3.244-3.244-3.244 3.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M977.902 145.303c4.249 0 7.493-1.694 9.732-5.093 2.232-3.4 3.351-8.338 3.351-14.826 0-6.487-1.119-11.425-3.351-14.825q-3.35-5.091-9.732-5.093c-4.256 0-7.494 1.694-9.72 5.093s-3.34 8.338-3.34 14.825q0 9.734 3.34 14.826c2.226 3.393 5.47 5.093 9.72 5.093m0-7.775c-1.395 0-2.388-.939-2.987-2.825-.598-1.879-.898-4.991-.898-9.319 0-4.327.3-7.433.898-9.306.599-1.874 1.592-2.813 2.987-2.813q2.091.001 2.998 2.813c.605 1.873.91 4.979.91 9.306q-.001 6.492-.91 9.319c-.604 1.886-1.604 2.825-2.998 2.825m-41.859-23.833-10.995 31.171h-9.229l11.623-31.171h-13.413v-7.798h22.02v7.798zm13.952 31.609c-3.568 0-6.434-.88-8.607-2.634-2.173-1.759-3.531-4.363-4.07-7.828l8.768-1.658q.325 4.345 3.747 4.345c1.179 0 2.089-.461 2.741-1.389s.976-2.28.976-4.075q0-2.881-.952-4.334-.95-1.454-2.663-1.454-2.632-.001-3.693 2.663l-8.062-.76 1.466-22.283h20.853v7.799h-13.084l-.598 7.529q2.199-2.118 5.566-2.118c3.058 0 5.5 1.107 7.314 3.315q2.729 3.313 2.729 9.158c0 4.351-1.149 7.721-3.448 10.121s-5.297 3.603-8.983 3.603",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__c",
    x1: 0,
    x2: 1686.15,
    y1: 34.615,
    y2: 34.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0037FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#620782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#E01132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#F39A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#F39A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#F31E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#620782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#0037FE",
    stopOpacity: 0.933
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "#00FF7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__d",
    x1: -13.987,
    x2: 53.818,
    y1: 5.251,
    y2: 9.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#F1010D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB0144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__f",
    x1: 120.091,
    x2: 188.213,
    y1: 13.534,
    y2: 17.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0035F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0035FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__g",
    x1: 206.353,
    x2: 257.791,
    y1: 19.064,
    y2: 22.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03CEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__h",
    x1: 206.352,
    x2: 257.79,
    y1: 19.064,
    y2: 22.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03CEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__k",
    x1: 322.682,
    x2: 363.752,
    y1: 10.942,
    y2: 32.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0035FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__l",
    x1: 389.999,
    x2: 431.069,
    y1: 15.162,
    y2: 36.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__n",
    x1: 601.362,
    x2: 525.361,
    y1: 49.222,
    y2: 19.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#FE5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#F3981E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#F3981E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03CEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__o",
    x1: 591.303,
    x2: 659.425,
    y1: 43.074,
    y2: 47.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0035F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0035FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__p",
    x1: 623.725,
    x2: 618.341,
    y1: 59.102,
    y2: 18.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#000AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#F39B1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__q",
    x1: 677.564,
    x2: 729.003,
    y1: 48.605,
    y2: 51.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03CEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__r",
    x1: 677.564,
    x2: 729.002,
    y1: 48.604,
    y2: 51.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03CEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__w",
    x1: 793.804,
    x2: 843.707,
    y1: 55.892,
    y2: 59.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03CEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__x",
    x1: 860.567,
    x2: 928.689,
    y1: 59.954,
    y2: 64.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94066F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE0004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__y",
    x1: 1005.26,
    x2: 929.257,
    y1: 74.543,
    y2: 45.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#FE5600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#F3981E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#F3981E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03CEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroBannerMobile_svg__B",
    x1: 0,
    x2: 2101.54,
    y1: 34.615,
    y2: 34.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#A9FF5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#5E9E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#3A42A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#461A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    stopColor: "#620782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#E01132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#F47C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F39A1E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "heroBannerMobile_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(39.86714 40.2656 -40.26574 39.86728 88.824 -12.967)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#F62913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#F29A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#2FBCC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#145BBC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "heroBannerMobile_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(73.331 139.938 224.227)scale(68.8754 67.0741)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#25DCA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#0035FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FC0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#FC0300"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "heroBannerMobile_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-162.47 279.687 -14.813)scale(114.926 155.974)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#25DCA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#0035FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FC0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#FC0300"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "heroBannerMobile_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(47.913 329.73 762.755)scale(92.4742 95.2415)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#01DC96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "heroBannerMobile_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(73.331 355.703 555.487)scale(68.8754 67.0741)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#25DCA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#0035FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FC0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#FC0300"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "heroBannerMobile_svg__v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(20.7138 0 0 20.7691 760.581 53.034)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#F50007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#94384D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#3C56A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "heroBannerMobile_svg__z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-19.75753 -65.98076 64.25517 -19.2408 1003.76 68.808)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#25DCA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#0035FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FC0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#FC0300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "heroBannerMobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v160H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "heroBannerMobile_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-415.669-55.384 1267.177 50.113l-4.331 69.096L-420.001 13.71z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "heroBannerMobile_svg__A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-578.462 90.77h2101.54V160h-2101.54z"
  })))));
};
export default SvgHeroBannerMobile;